export const description = {
  selfie: 'Posicione corretamente seu rosto no local marcado.',
  documents: 'Posicione corretamente o documento nas marcações.',
};
